import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCellphone({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4a1 1 0 00-1 1v14a1 1 0 001 1h8a1 1 0 001-1V5a1 1 0 00-1-1H8zm0-2h8a3 3 0 013 3v14a3 3 0 01-3 3H8a3 3 0 01-3-3V5a3 3 0 013-3zm3 14h2a1 1 0 010 2h-2a1 1 0 110-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCellphone
